import { Form, Input, Modal, Select, Spin, DatePicker } from 'antd';
import React, { Component } from 'react';
import moment from 'moment';
import './style.css';

const { Option } = Select;

class SenderPoolForm extends Component {
  componentDidUpdate = async (prevProps) => {
    const { data: pd } = prevProps;
    const { data: d, form } = this.props;

    if (
      (d &&
        (d.id !== pd.id ||
          d.country_abbr !== pd.country_abbr ||
          d.gateway_id !== pd.gateway_id)) ||
      d.sender !== pd.sender ||
      d.registered_date !== pd.registered_date ||
      d.expired_date !== pd.expired_date
    ) {
      const formData = {
        ...d,
        registered_date: d.registered_date ? moment.unix(d.registered_date) : null,
        expired_date: d.expired_date ? moment.unix(d.expired_date) : null,
      };
      form.setFieldsValue(formData);
    }
  };

  handleCancelModal = () => {
    const { onCancel, form } = this.props;

    form.resetFields();
    onCancel();
  };
  
  disabledExpiredDate = (current) => {
    const { form } = this.props;
    const registeredDate = form.getFieldValue('registered_date');
    
    if (!registeredDate) {
      return false;
    }
    
    return current && current < registeredDate.startOf('day');
  };
  
  handleRegisterDateChange = (date) => {
    const { form } = this.props;
    const expiredDate = form.getFieldValue('expired_date');
    
    if (expiredDate && date && expiredDate.isBefore(date)) {
      form.setFieldsValue({
        expired_date: null,
      });
    }
  };

  render() {
    const {
      visible,
      onCreate,
      form,
      flagCreateOrUpdateForm,
      countryList,
      gatewayList,
      loading,
      data,
    } = this.props;
    const { getFieldDecorator } = form;

    let okText = flagCreateOrUpdateForm ? 'เพิ่ม' : 'แก้ไข';
    let title =
      okText + ' Senders Pool' + (data.id ? ` - SENDERSPOOL${data.id || 0}` : '');

    return (
      <Modal
        visible={visible}
        title={title}
        okText={okText}
        cancelText="ยกเลิก"
        onCancel={this.handleCancelModal}
        onOk={onCreate}
        maskClosable={false}
        style={{ top: 20 }}
      >
        <Spin spinning={loading} tip="กำลังบันทึกข้อมูล...">
          <Form className="senders_pool_form">
            {getFieldDecorator('id')(<Input type="hidden" />)}
            {getFieldDecorator('is_default')(<Input type="hidden" />)}
            <Form.Item label="Gateway">
              {getFieldDecorator('gateway_id', {
                rules: [{ required: true, message: 'กรุณาเลือก Gateway' }],
              })(
                <Select
                  showSearch
                  placeholder="กรุณาเลือก Gateway"
                  optionFilterProp="children"
                  filterOption={
                    (input, option) => {
                      if (!option.props.children) return false;
                      return (
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }
                    //   option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={this.handleChange}
                >
                  {gatewayList.map((item, i) => (
                    <Option key={i} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>,
              )}
            </Form.Item>
            <Form.Item label="ประเทศ">
              {getFieldDecorator('country_abbr', {
                rules: [{ required: true, message: 'กรุณาเลือกประเทศ' }],
              })(
                <Select
                  showSearch
                  placeholder="กรุณาเลือกประเทศ"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {countryList.map((item, i) => (
                    <Option key={i} value={item.region_code}>
                      {item.name}
                    </Option>
                  ))}
                </Select>,
              )}
            </Form.Item>
            <Form.Item label="Sender">
              {getFieldDecorator('sender', {
                rules: [
                  {
                    message:
                      'Sender ต้องประกอบไปด้วย A-Z a-z 0-9 . - _ และต้องไม่เกิน 11 ตัวอักษร',
                    pattern: /^[a-zA-Z0-9._-][a-zA-Z0-9._\s-]{0,9}[a-zA-Z0-9._-]$/,
                    required: true,
                  },
                ],
              })(<Input />)}
            </Form.Item>
            
            <Form.Item label="Registered Date">
              {getFieldDecorator('registered_date')(
                <DatePicker
                    format="YYYY-MM-DD"
                    placeholder="Select Registered Date"
                    style={{ width: '100%' }}
                    onChange={this.handleRegisterDateChange}
                />
              )}
            </Form.Item>
            <Form.Item label="Expired Date">
              {getFieldDecorator('expired_date')(
                <DatePicker
                    format="YYYY-MM-DD"
                    placeholder="Select Expired Date"
                    style={{ width: '100%' }}
                    disabledDate={this.disabledExpiredDate}
                />
              )}
            </Form.Item>
          </Form>
        </Spin>
      </Modal>
    );
  }
}

export default Form.create({ name: 'senders_pool_form' })(SenderPoolForm);


// WEBPACK FOOTER //
// ./src/containers/SendersPool/form.js